import React from 'react'
import { update_page_meta } from '../../actions/page/header'
import { connect } from 'react-redux';

const TargetDetail = ({ update_page_meta }) => {
    update_page_meta({
        title: "Target Detail",
        description: "Detailed information of a Target",
      });
    
  return (
    <div>TargetDetail</div>
  )
}

export default connect(null, {update_page_meta}) (TargetDetail);